import { Link, useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { searchAll } from "@/lib/search";
import useTitle from "@/lib/useTitle";

export default function Pesquisa() {
  useTitle("Pesquisa");
  const site = useSite();
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const results = searchAll(site, q);
  return (
    <div className="container-x py-12 max-w-4xl">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold">Pesquisa</h1>
      <label className="relative block mt-6">
        <span className="sr-only">Termo de pesquisa</span>
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-500" aria-hidden />
        <input autoFocus value={q} onChange={(e) => setParams({ q: e.target.value }, { replace: true })} placeholder="Atividades, organizações, locais, conteúdos…" className="h-14 w-full rounded-2xl border border-black/15 bg-white pl-12 pr-4 text-lg" data-testid="search-page-input" />
      </label>
      <p className="mt-4 text-sm text-slate-600" aria-live="polite" data-testid="search-page-count">{q.length > 1 ? `${results.length} resultado${results.length === 1 ? "" : "s"}` : "Escreva pelo menos 2 letras."}</p>
      <ul className="mt-6 divide-y bg-white rounded-2xl border">
        {results.map((r) => <li key={r.type + r.id}><Link to={r.to} className="flex items-center justify-between gap-4 p-4 hover:bg-black/5 min-h-[56px]" data-testid={`search-page-result-${r.id}`}><span className="font-semibold">{r.title}</span><span className="eyebrow text-slate-500 shrink-0">{r.type}</span></Link></li>)}
      </ul>
    </div>
  );
}
